import { CalendarPlus } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { API } from "@/lib/api";

const HOURS = 3; // concerts only have a start time: 3 h slot in the calendar

// "2026-12-04T20:00:00" (Paris time) -> "20261204T200000"
const compact = (d) => d.replace(/[-:]/g, "").slice(0, 15);
const plusHours = (iso) => {
  const d = new Date(iso);
  d.setHours(d.getHours() + HOURS);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}:00`;
};

const targets = (e) => {
  const url = `${window.location.origin}/agenda/${e.slug}`;
  const where = [e.venue, e.address?.split(" Facebook")[0], e.city].filter(Boolean).join(", ");
  const end = plusHours(e.date);
  const ics = `${API}/events/${e.slug}/calendar.ics`;
  return [
    { key: "google", label: "Google Agenda", href: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(e.title)}&dates=${compact(e.date)}/${compact(end)}&ctz=Europe/Paris&location=${encodeURIComponent(where)}&details=${encodeURIComponent(url)}` },
    { key: "apple", label: "Apple Calendrier", href: ics },
    { key: "outlook", label: "Outlook", href: `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(e.title)}&startdt=${e.date.slice(0, 19)}&enddt=${end}&location=${encodeURIComponent(where)}&body=${encodeURIComponent(url)}` },
    { key: "ics", label: "Autre agenda (.ics)", href: ics },
  ];
};

export const AddToCalendar = ({ event, className = "" }) => (
  <DropdownMenu>
    <DropdownMenuTrigger data-testid="add-to-calendar-trigger" className={`inline-flex items-center justify-center gap-3 outline-none transition-colors duration-200 ${className}`}>
      <CalendarPlus className="w-5 h-5" /> Mon agenda
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="rounded-none bg-black border-white/10 min-w-[220px] z-[120]">
      {targets(event).map((t) => (
        <DropdownMenuItem key={t.key} asChild className="rounded-none focus:bg-primary focus:text-white cursor-pointer">
          <a href={t.href} target={t.key === "google" || t.key === "outlook" ? "_blank" : undefined} rel="noreferrer"
            data-testid={`add-to-calendar-${t.key}`} className="uppercase text-xs font-bold tracking-[0.15em] py-3">
            {t.label}
          </a>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
